import networkCompanyList from './networkCompanyList';
import oauth2Code from './oauth2Code';
import connectionList from './connectionList';
import getUnitAll from './getUnitAll';

export default {
    /** 平台网络公司列表 */
    networkCompanyList,

    /** 获取在平台Code */
    oauth2Code,

    /** 公司列表 */
    connectionList,

    /** 获取单位列表 */
    getUnitAll,
};



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/api/platform/index.ts